module.exports = __webpack_public_path__ + "img/c7.31dd1a62.png";